import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { createBrowserRouter, RouterProvider } from "react-router";
import { configureScene } from "./loaders.ts";
import Scene from "./components/Scene.tsx";
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { DeviceProvider } from "./contexts/DeviceContext.tsx";
import { RemoteNavigationProvider } from "./contexts/RemoteNavigationContext.tsx";
import { eventStartGame } from "./utils/gtag.ts";
import { SCENES } from "../config/scenes.ts";
import { GlobalStateProvider } from "./contexts/GlobalStateContext.tsx";

const router = createBrowserRouter([
	{
		path: "/",
		Component: App,
		children: [
			{
				index: true,
				Component: Scene,
				loader: () => configureScene(SCENES.SPLASH_SCREEN),
			},
			{
				path: SCENES.CABIN_EXIT.path,
				loader: () => configureScene(SCENES.CABIN_EXIT),
				Component: Scene,
			},
			{
				path: SCENES.CABIN_HUB.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_HUB),
			},
			{
				path: SCENES.CABIN_CAT.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_CAT),
			},
			{
				path: SCENES.CABIN_COUCH.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_COUCH),
			},
			{
				path: SCENES.CABIN_DESK.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_DESK),
			},
			{
				path: SCENES.CABIN_DESK_DRAWER.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_DESK_DRAWER),
			},
			{
				path: SCENES.CABIN_FIREPLACE.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_FIREPLACE),
			},
			{
				path: SCENES.CABIN_GAME_TABLE.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_GAME_TABLE),
			},
			{
				path: SCENES.CABIN_LIBRARY.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_LIBRARY),
			},
			{
				path: SCENES.CABIN_RADIO.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_RADIO),
			},
			{
				path: SCENES.CABIN_WINDOW.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_WINDOW),
			},
			{
				path: SCENES.CABIN_KITCHEN.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABIN_KITCHEN),
			},
			{
				path: SCENES.CABANA.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABANA),
			},
			{
				path: SCENES.CABANA_BEACH.path,
				Component: Scene,
				loader: () => configureScene(SCENES.CABANA_BEACH),
			},
			{
				path: SCENES.PLANE.path,
				Component: Scene,
				loader: () => configureScene(SCENES.PLANE),
			},
			{
				path: SCENES.PLANE_RETURN.path,
				Component: Scene,
				loader: () => configureScene(SCENES.PLANE_RETURN),
			},
			{
				path: SCENES.INTERACTIVE_CAT.path,
				Component: Scene,
				loader: () => configureScene(SCENES.INTERACTIVE_CAT),
			},
		],
	},
]);

// Track game start
eventStartGame();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<DeviceProvider>
			<AuthProvider>
				<GlobalStateProvider>
					<RemoteNavigationProvider>
						<RouterProvider router={router} />
					</RemoteNavigationProvider>
				</GlobalStateProvider>
			</AuthProvider>
		</DeviceProvider>
	</StrictMode>,
);
